import HealthRecordDate from './HealthRecordDate';

export default HealthRecordDate;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordDate/index.js